// $FlowFixMe
import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
`;

export const Form = styled.form`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  margin-top: 32px;
`;
